import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { CredentialChip, Icon, StatusChip, VenueChip, colors } from "../ui/index.js";
import { CourtGrid } from "./CourtGrid.js";
import { venueCourtCount } from "../../lib/venue-names.js";
import { formatSessionSubline, formatTimeRange } from "../../lib/format-session.js";
function formatDayLabel(iso) {
    const d = new Date(iso);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const sameDay = (a, b) => a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();
    if (sameDay(d, today))
        return "Today";
    if (sameDay(d, tomorrow))
        return "Tomorrow";
    return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
}
export function SessionRow({ session, credential, isFirst, showDay }) {
    const credentialLabel = session.credentialId
        ? credential?.label ?? "(unknown)"
        : null;
    const totalCourts = session.courts.total || session.courtDetails?.length || 0;
    const subline = formatSessionSubline(session.startTime, session.endTime, totalCourts);
    return (_jsxs(Link, { to: `/sessions/${session.id}`, style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 12,
            padding: "12px 14px",
            borderTop: isFirst ? "none" : `1px solid ${colors.border}`,
            textDecoration: "none",
            color: colors.text,
            background: colors.surface,
            transition: "background 0.15s",
        }, onMouseEnter: (e) => {
            e.currentTarget.style.background = colors.surfaceSecondary;
        }, onMouseLeave: (e) => {
            e.currentTarget.style.background = colors.surface;
        }, children: [_jsxs("div", { style: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 7 }, children: [_jsxs("div", { style: { display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }, children: [showDay && (_jsx("span", { style: { color: colors.text, fontWeight: 700, fontSize: "0.95rem" }, children: formatDayLabel(session.startTime) })), _jsx("span", { style: {
                                    color: showDay ? colors.textSecondary : colors.text,
                                    fontWeight: showDay ? 600 : 700,
                                    fontSize: "0.95rem",
                                    fontVariantNumeric: "tabular-nums",
                                }, children: formatTimeRange(session.startTime, session.endTime) }), _jsx("span", { style: {
                                    color: colors.textSecondary,
                                    fontSize: "0.78rem",
                                    fontVariantNumeric: "tabular-nums",
                                }, children: subline }), session.crossCredential && (_jsx("span", { title: "Shares this venue + time with another credential", style: { display: "inline-flex", alignItems: "center", color: colors.warning }, children: _jsx(Icon, { name: "git-merge", size: 13, color: colors.warning }) }))] }), _jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }, children: [session.venueId && _jsx(VenueChip, { venueId: session.venueId, maxWidth: 150 }), credentialLabel && (_jsx(CredentialChip, { label: credentialLabel, colorKey: session.credentialId ?? credentialLabel, maxWidth: 180 }))] }), session.courtDetails && session.courtDetails.length > 0 && (_jsx("div", { style: { maxWidth: 340, overflowX: "auto" }, children: _jsx(CourtGrid, { compact: true, courtCount: venueCourtCount(session.venueId), slots: session.courtDetails.map((cd, i) => ({
                                id: `${i}`,
                                startTime: cd.startTime ?? session.startTime,
                                status: cd.status,
                                courtNumber: cd.courtNumber ?? null,
                                origin: cd.origin,
                            })) }) }))] }), _jsx(StatusChip, { status: session.status })] }));
}
